/* BuyVerse 3D Animated — lightweight interaction layer */
(function(){
  "use strict";
  if(window.__BV3_GLOBAL__) return;
  window.__BV3_GLOBAL__=true;
  var reduce=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var touch=window.matchMedia("(hover: none)").matches;

  function tilt(el){
    if(reduce||touch||el.dataset.bv3Tilt)return;
    el.dataset.bv3Tilt="1";
    el.addEventListener("pointermove",function(e){
      var r=el.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-.5;
      var y=(e.clientY-r.top)/r.height-.5;
      el.style.transform="perspective(1100px) rotateY("+(x*7)+"deg) rotateX("+(-y*6)+"deg) translateY(-4px)";
    });
    el.addEventListener("pointerleave",function(){el.style.transform=""});
  }

  function initTilts(root){
    (root||document).querySelectorAll(".product-card-wrapper,.card-wrapper,.collection-list__item").forEach(tilt);
  }

  function initReveal(root){
    if(reduce)return;
    var nodes=(root||document).querySelectorAll("main .shopify-section:not(.bv3-observed)");
    if(!nodes.length)return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    },{rootMargin:"0px 0px -8% 0px",threshold:.06});
    nodes.forEach(function(n){
      n.classList.add("bv3-observed","bv3-reveal");
      io.observe(n);
    });
  }

  function init(){
    initTilts(document);
    initReveal(document);
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
  document.addEventListener("shopify:section:load",function(e){
    initTilts(e.target);
    initReveal(e.target);
  });
})();


/* BuyVerse ambient parallax — subtle, disabled on touch/reduced-motion */
(function(){
  "use strict";
  var bg=document.getElementById("bv3-ambient-bg");
  if(!bg)return;
  var reduce=matchMedia("(prefers-reduced-motion: reduce)").matches;
  var touch=matchMedia("(hover: none)").matches;
  if(reduce||touch)return;

  var raf=0, tx=0, ty=0, cx=0, cy=0;
  function render(){
    raf=0;
    cx+=(tx-cx)*.055;
    cy+=(ty-cy)*.055;
    bg.style.transform="translate3d("+(cx*12)+"px,"+(cy*10)+"px,0)";
  }
  addEventListener("pointermove",function(e){
    tx=(e.clientX/innerWidth)-.5;
    ty=(e.clientY/innerHeight)-.5;
    if(!raf)raf=requestAnimationFrame(render);
  },{passive:true});
})();
